/*==============================================================================
  Cart Drawer - Minimal Test Version
==============================================================================*/
console.log('[Cart drawer] - JS file loaded - MINIMAL VERSION');

const FREE_SHIPPING_THRESHOLD_CENTS = 6000; // $70.00

// Collect SVG asset URLs from hidden div inserted in Liquid
const AssetEl = document.getElementById('CartDrawerAssets');
const SVG_ASSETS = AssetEl ? {
  stars: AssetEl.dataset.stars,
  left: AssetEl.dataset.left,
  right: AssetEl.dataset.right,
  bulletActive: AssetEl.dataset.bulletActive,
  bulletInactive: AssetEl.dataset.bulletInactive,
  starYellow: AssetEl.dataset.starYellow,
  seal: AssetEl.dataset.seal,
  trash: AssetEl.dataset.trash,
} : {};

// Simple cart drawer object
window.CartDrawer = {
  open: function() {
    console.log('[Cart drawer] - OPEN called');
    var drawer = document.getElementById('CartDrawer');
    var overlay = document.getElementById('CartDrawerOverlay');
    
    if (!drawer || !overlay) {
      console.error('[Cart drawer] - Elements not found');
      console.log('Drawer:', !!drawer, 'Overlay:', !!overlay);
      return;
    }
    
    this.refresh();
    
    drawer.classList.add('cart-drawer--open');
    overlay.classList.add('cart-drawer__overlay--visible');
    document.body.style.overflow = 'hidden';
  },
  
  close: function() {
    console.log('[Cart drawer] - CLOSE called');
    var drawer = document.getElementById('CartDrawer');
    var overlay = document.getElementById('CartDrawerOverlay');
    
    if (drawer) drawer.classList.remove('cart-drawer--open');
    if (overlay) overlay.classList.remove('cart-drawer__overlay--visible');
    document.body.style.overflow = '';
  },
  
  refreshVariantMap: function(){
    // Fetch the section that outputs the latest variant map JSON and merge it into the existing map
    return fetch('/?section_id=cart-drawer-variant-map')
      .then(function(res){ return res.text(); })
      .then(function(html){
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var script = doc.getElementById('CartDrawerVariantMapJSON');
        if (script) {
          try {
            var map = JSON.parse(script.textContent || '{}');
            window.CartDrawerVariantMap = Object.assign({}, window.CartDrawerVariantMap || {}, map);
            console.log('[Cart drawer] - Variant map refreshed', window.CartDrawerVariantMap);
          } catch(e){
            console.error('[Cart drawer] - Error parsing variant map JSON', e);
          }
        }
      })
      .catch(function(err){
        console.error('[Cart drawer] - Error fetching variant map section', err);
      });
  },

  refresh: function() {
    console.log('[Cart drawer] - Refreshing cart');
    var self = this;
    // Refresh variant map in parallel with cart JSON fetch
    var mapPromise = self.refreshVariantMap();

    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        console.log('[Cart drawer] - Cart data received:', cart);
        // Ensure variant map finished (or failed) before rendering to get latest recommendations
        Promise.resolve(mapPromise).finally(function(){
          window.CartDrawer.render(cart);
        });
      })
      .catch(function(error) {
        console.error('[Cart drawer] - Error fetching cart:', error);
      });
  },
  
  updateQuantity: function(line, quantity) {
    console.log('[Cart drawer] - Updating line', line, 'to quantity', quantity);
    
    var formData = new FormData();
    formData.append('line', line);
    formData.append('quantity', quantity);
    
    fetch('/cart/change.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      console.log('[Cart drawer] - Quantity updated');
      window.CartDrawer.render(cart);
    })
    .catch(function(error) {
      console.error('[Cart drawer] - Error updating quantity:', error);
    });
  },

  render: function(cart) {
    console.log('[Cart drawer] - Rendering cart with', cart.item_count, 'items');
    
    var drawer = document.getElementById('CartDrawer');
    var itemsContainer = drawer.querySelector('.cart-drawer__items');
    var recContainer   = drawer.querySelector('.cart-drawer__recommendations');
    var subtotal = drawer.querySelector('.js-cart-drawer-subtotal');
    var freeShippingEl = drawer.querySelector('.js-cart-drawer-free-shipping');
    
    if (!itemsContainer) {
      console.error('[Cart drawer] - Body element not found');
      return;
    }
    
    // Helper function to format money
    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    
    // Build cart items HTML with better styling
    var itemsHtml = cart.items.map(function(item, idx) {
      var img = item.image ? item.image.replace(/(\.[^.]*$)/, '_160x160_crop_center$1') : '';
      
      // Build variant text
      var variantText = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantText = '<p class="cart-drawer__variant">' + item.variant_title + '</p>';
      }
      
      // Show price per item vs line price
      var unitPrice = '';
      if (item.quantity > 1) {
        unitPrice = '<small>' + formatMoney(item.original_price) + ' each</small>';
      }
      
      return `
        <div class="cart-drawer__item" data-line="${idx+1}">
          <div class="cart-drawer__image">
            <img src="${img}" alt="${item.product_title}" loading="lazy">
          </div>
          <div>
            <p class="cart-drawer__name">${item.product_title}</p>
            <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
              <div class="cart-drawer__details">
                ${variantText}
                <p class="cart-drawer__price">${formatMoney(item.final_line_price)} ${unitPrice}</p>
              </div>
              <div class="cart-drawer__actions">
                <div class="cart-drawer__qty">
                  <button class="cart-drawer__qty-btn js-cart-drawer-minus" aria-label="Decrease quantity" data-line="${idx+1}">&minus;</button>
                  <input class="cart-drawer__qty-input js-cart-drawer-qty" data-line="${idx+1}" type="text" value="${item.quantity}" min="0">
                  <button class="cart-drawer__qty-btn js-cart-drawer-plus" aria-label="Increase quantity" data-line="${idx+1}">+</button>
                </div>
                <button class="cart-drawer__remove js-cart-drawer-remove" aria-label="Remove item" data-line="${idx+1}">
                  <img class="cart-drawer__remove-icon" src="${SVG_ASSETS.trash}" alt="">
                  <span>Remove</span>
                </button>
              </div>
            </div>
          </div>
        </div>`;
    }).join('');
    
    itemsContainer.innerHTML = itemsHtml || '<p>Your cart is currently empty.</p>';
    
    if (subtotal) {
      subtotal.textContent = formatMoney(cart.total_price);
    }

    // Update free-shipping message
    if (freeShippingEl) {
      if (cart.total_price >= FREE_SHIPPING_THRESHOLD_CENTS) {
        freeShippingEl.innerHTML = 'You have unlocked <strong>FREE SHIPPING!</strong>';
      } else {
        var remaining = FREE_SHIPPING_THRESHOLD_CENTS - cart.total_price;
        freeShippingEl.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> to your cart to get <strong>FREE SHIPPING!</strong>';
      }
    }

    // Build recommendation section
    window.CartDrawer.buildRecommendations(cart).then(function(recs){
      window.CartDrawer.recs = recs;
      window.CartDrawer.recIndex = 0;
      window.CartDrawer.updateRecommendationUI();
    });

    // Update cart count in header
    var cartCount = document.getElementById('CartCount');
    if (cartCount) {
      cartCount.textContent = cart.item_count;
    }
  },

  // ----- Recommendation helpers ----- //
  recs: [],
  recIndex: 0,
  recCache: {},

  buildRecommendations: function(cart){
    var self = this;
    var promises = [];
    var seenRecVariantIds = new Set();

    function extractVariantId(val){
      if (!val) return null;
      if (typeof val === 'number') return val;
      if (typeof val === 'string') {
        var match = val.match(/(\d+)$/);
        return match ? match[1] : null;
      }
      if (typeof val === 'object' && val.value) {
        return extractVariantId(val.value);
      }
      return null;
    }

    var variantMap = (typeof window !== 'undefined' && window.CartDrawerVariantMap) ? window.CartDrawerVariantMap : {};

    cart.items.forEach(function(item){
      var mappedId = variantMap[item.variant_id];
      if (mappedId && !seenRecVariantIds.has(mappedId)) {
        seenRecVariantIds.add(mappedId);
        promises.push(self.fetchVariant(mappedId));
        return; // Skip further lookup for this item
      }

      // Fallback: fetch product JSON and inspect variant metafield (for cases where mapping is missing)
      promises.push(self.fetchProduct(item.handle).then(function(product){
        if (!product) return null;
        var currentVar = product.variants.find(function(v){return v.id === item.variant_id;});
        console.log('currentVar', currentVar);
        if (!currentVar || !currentVar.metafields || !currentVar.metafields.custom) return null;

        var raw = currentVar.metafields.custom.recommended_variants;
        if (raw && raw.value !== undefined) raw = raw.value;
        var recId = extractVariantId(raw);

        if (!recId || seenRecVariantIds.has(recId)) return null;
        seenRecVariantIds.add(recId);
        return self.fetchVariant(recId);
      }));
    });

    return Promise.all(promises).then(function(results){
      return results.filter(Boolean);
    });
  },

  fetchProduct: function(handle){
    var self = this;
    if (self.recCache[handle]) return Promise.resolve(self.recCache[handle]);
    return fetch('/products/' + handle + '.js').then(function(res){return res.json();}).then(function(json){
      self.recCache[handle] = json;
      return json;
    }).catch(function(){return null;});
  },

  fetchVariant: function(id){
    var self = this;
    var cacheKey = 'var_' + id;
    if (self.recCache[cacheKey]) return Promise.resolve(self.recCache[cacheKey]);

    return fetch('/variants/' + id + '.js')
      .then(function(res){ return res.json(); })
      .then(function(variant){
        if (!variant) return null;

        // Derive product handle from variant URL, e.g. "/products/handle?variant=123"
        var handleMatch = variant.url ? variant.url.match(/\/products\/([^?]+)/) : null;
        var handle = handleMatch ? handleMatch[1] : null;

        var productPromise = handle ? self.fetchProduct(handle) : Promise.resolve({
          title: variant.name ? variant.name.split(' - ')[0] : '',
          images: [variant.featured_image ? variant.featured_image.src : '']
        });

        return productPromise.then(function(product){
          var obj = { product: product, variant: variant };
          self.recCache[cacheKey] = obj;
          return obj;
        });
      })
      .catch(function(){ return null; });
  },

  findBiggerVariant: function(currentVariantId, product){
    if (!product) return null;
    var currentVariant = product.variants.find(function(v){return v.id === currentVariantId;});
    if (!currentVariant) return null;
    // Define bigger as higher price
    var bigger = product.variants.filter(function(v){return v.available && v.price > currentVariant.price;})
                                 .sort(function(a,b){return a.price - b.price;})[0];
    return bigger || null;
  },

  /*
  updateRecommendationUI: function(){
    var drawer = document.getElementById('CartDrawer');
    var recContainer = drawer.querySelector('.cart-drawer__recommendations');
    if (!recContainer) return;
    if (!this.recs || this.recs.length === 0) {
      recContainer.innerHTML = '';
      // Hide the recommendations section entirely when nothing to show
      recContainer.style.display = 'none';
      return;
    }
    // Ensure it is visible when we do have recommendations
    recContainer.style.removeProperty('display');
    var idx = this.recIndex % this.recs.length;
    var rec = this.recs[idx];
    function formatMoney(c){return '$' + (c/100).toFixed(2);}    
    var stars = SVG_ASSETS.stars || '';
    var leftArrow  = SVG_ASSETS.left || '';
    var rightArrow = SVG_ASSETS.right || '';
    var ellipseActive   = SVG_ASSETS.bulletActive || '';
    var ellipseInactive = SVG_ASSETS.bulletInactive || '';
    var bulletsHtml = this.recs.map(function(_,i){
      var src = (i===idx) ? ellipseActive : ellipseInactive;
      return '<img class="cart-drawer__bullet" src="'+src+'" alt="">';
    }).join('');

    var product_title = rec.product.title + ' - ' + rec.variant.title;

    var html = `
      <div class="cart-drawer__recommendations-container">
        <div class="cart-drawer__upsell-header">
          <img class="cart-drawer__stars" src="${stars}" alt="Stars" width="71" height="8">
          <h4 class="cart-drawer__upsell-title">YOU MAY ALSO LIKE</h4>
          <img class="cart-drawer__stars" src="${stars}" alt="Stars" width="71" height="8">
        </div>
        <div class="cart-drawer__upsell-product">
          <img class="cart-drawer__upsell-img" src="${rec.variant.featured_image?.src || rec.product.images[0]}" alt="${rec.product.title}" loading="lazy">
          <div class="cart-drawer__upsell-details">
            <p class="cart-drawer__upsell-name">${product_title}</p>
            <div class="cart-drawer__upsell-price-container">
              <p class="cart-drawer__upsell-price">${formatMoney(rec.variant.price)}</p>
              <button class="cart-drawer__quick-add js-cart-drawer-quick-add" data-variant="${rec.variant.id}">+ QUICK ADD</button>
            </div>
          </div>
        </div>
        <div class="cart-drawer__upsell-nav">
          <button class="cart-drawer__upsell-prev" aria-label="Previous"><img src="${leftArrow}" alt="Prev"></button>
          <div class="cart-drawer__upsell-bullets">${bulletsHtml}</div>
          <button class="cart-drawer__upsell-next" aria-label="Next"><img src="${rightArrow}" alt="Next"></button>
        </div>
      </div>`;
    recContainer.innerHTML = html;
  } */

updateRecommendationUI: function(){
  var drawer = document.getElementById('CartDrawer');
  var recContainer = drawer.querySelector('.cart-drawer__recommendations');
  if (!recContainer) return;

  if (!this.recs || this.recs.length === 0) {
    recContainer.innerHTML = '';
    recContainer.style.display = 'none';
    return;
  }

  recContainer.style.removeProperty('display');

  var idx = this.recIndex % this.recs.length;
  var rec = this.recs[idx];

  function formatMoney(c){ return '$' + (c/100).toFixed(2); }

  var stars           = SVG_ASSETS.stars || '';
  var leftArrow       = SVG_ASSETS.left || '';
  var rightArrow      = SVG_ASSETS.right || '';
  var ellipseActive   = SVG_ASSETS.bulletActive || '';
  var ellipseInactive = SVG_ASSETS.bulletInactive || '';

  var bulletsHtml = this.recs.map(function(_, i){
    var src = (i === idx) ? ellipseActive : ellipseInactive;
    return '<img class="cart-drawer__bullet" src="'+ src +'" alt="">';
  }).join('');

  var product_title = rec.product.title + ' - ' + rec.variant.title;

  // generic placeholder (only if everything fails)
  var placeholderImg = 'https://cdn.shopify.com/s/files/1/0505/9497/1845/files/IMG_3353_45018fb0-19fa-43f9-a58e-aa0ecc8dbddd.jpg?v=1764250063';

  // base image detection
  var imgSrc =
    (rec.image && (rec.image.src || rec.image)) ||
    (rec.featured_image && (rec.featured_image.src || rec.featured_image)) ||
    (rec.variant &&
      rec.variant.featured_image &&
      (rec.variant.featured_image.src || rec.variant.featured_image)) ||
    (rec.product &&
      rec.product.featured_image &&
      (rec.product.featured_image.src || rec.product.featured_image)) ||
    (rec.product &&
      rec.product.images &&
      rec.product.images.length > 0 &&
      (rec.product.images[0].src || rec.product.images[0])) ||
    placeholderImg;

  // ---- PRODUCT-SPECIFIC PLACEHOLDERS (USE HANDLE, NOT TITLE) ----
    var handle = (rec.product.handle || "").toLowerCase();
    console.log("REAL HANDLE:", handle);

    var imgSrc;

    if (
      rec.product.title &&
      rec.product.title.trim() === "No Sugar Ketchup 3-Gallon Vol-Pak (Bag-in-Box)"
    ) {
      imgSrc = "https://cdn.shopify.com/s/files/1/0505/9497/1845/files/TMF_Pump_Dispenser_NS-Ketchup-MR1_1.jpg?v=1764244423";
    }

    if (
      rec.product.title &&
      rec.product.title.trim() === "Honey Mustard All-Natural Bulk 3-Gallon VolPak (Bag-in-Box)"
    ) {
      imgSrc = "https://cdn.shopify.com/s/files/1/0505/9497/1845/files/TMF_Pump_Dispenser_Honey_Mustard-MR1.png?v=1746641494";
    }

    if (
      rec.product.title &&
      rec.product.title.trim() === "German-Style Stone Ground Mustard All-Natural Bulk 3-Gallon VolPak (Bag-in-Box)"
    ) {
      imgSrc = "https://cdn.shopify.com/s/files/1/0505/9497/1845/files/TMF_Pump_Dispenser_Bavarian_Mustard-MR1.png?v=1764249749";
    }

    if (
      rec.product.title &&
      rec.product.title.trim() === "Pitmaster Original Low Sugar BBQ Sauce Bulk 3-Gallon Vol-Pak (Bag-in-Box)"
    ) {
      imgSrc = "https://cdn.shopify.com/s/files/1/0505/9497/1845/files/TMF_Pump_Dispenser_KC_BBQ-MR1.png?v=1746641176";
    }

  var html = `
    <div class="cart-drawer__recommendations-container">
      <div class="cart-drawer__upsell-header">
        <img class="cart-drawer__stars" src="${stars}" alt="Stars" width="71" height="8">
        <h4 class="cart-drawer__upsell-title">YOU MAY ALSO LIKE</h4>
        <img class="cart-drawer__stars" src="${stars}" alt="Stars" width="71" height="8">
      </div>
      <div class="cart-drawer__upsell-product">
        <img
          class="cart-drawer__upsell-img"
          src="${imgSrc}"
          alt="${rec.product.title}"
          loading="lazy"
        />
        <div class="cart-drawer__upsell-details">
          <p class="cart-drawer__upsell-name">${product_title}</p>
          <div class="cart-drawer__upsell-price-container">
            <p class="cart-drawer__upsell-price">${formatMoney(rec.variant.price)}</p>
            <button class="cart-drawer__quick-add js-cart-drawer-quick-add" data-variant="${rec.variant.id}">
              + QUICK ADD
            </button>
          </div>
        </div>
      </div>
      <div class="cart-drawer__upsell-nav">
        <button class="cart-drawer__upsell-prev" aria-label="Previous">
          <img src="${leftArrow}" alt="Prev">
        </button>
        <div class="cart-drawer__upsell-bullets">${bulletsHtml}</div>
        <button class="cart-drawer__upsell-next" aria-label="Next">
          <img src="${rightArrow}" alt="Next">
        </button>
      </div>
    </div>
  `;

  recContainer.innerHTML = html;
}

};

// Simple initialization
document.addEventListener('DOMContentLoaded', function() {
  console.log('[Cart drawer] - DOM ready - MINIMAL');
  
  // Bind cart triggers
  document.addEventListener('click', function(e) {
    if (e.target.closest('.js-cart-drawer-open, .js-cart-trigger')) {
      console.log('[Cart drawer] - TRIGGER CLICKED');
      e.preventDefault();
      e.stopPropagation();
      window.CartDrawer.open();
    }
  });
  
  // Bind close triggers
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cart-drawer__close, .cart-drawer__overlay')) {
      console.log('[Cart drawer] - CLOSE CLICKED');
      e.preventDefault();
      window.CartDrawer.close();
    }
  });
  
  // Bind quantity controls
  document.addEventListener('click', function(e) {
    // Plus button
    if (e.target.closest('.js-cart-drawer-plus')) {
      var button = e.target.closest('.js-cart-drawer-plus');
      var line = button.dataset.line;
      var input = document.querySelector('.js-cart-drawer-qty[data-line="' + line + '"]');
      if (input) {
        var newQty = parseInt(input.value, 10) + 1;
        window.CartDrawer.updateQuantity(line, newQty);
      }
    }
    
    // Minus button
    if (e.target.closest('.js-cart-drawer-minus')) {
      var button = e.target.closest('.js-cart-drawer-minus');
      var line = button.dataset.line;
      var input = document.querySelector('.js-cart-drawer-qty[data-line="' + line + '"]');
      if (input) {
        var newQty = Math.max(0, parseInt(input.value, 10) - 1);
        window.CartDrawer.updateQuantity(line, newQty);
      }
    }

    // Remove button
    if (e.target.closest('.js-cart-drawer-remove')) {
      var button = e.target.closest('.js-cart-drawer-remove');
      var line = button.dataset.line;
      window.CartDrawer.updateQuantity(line, 0);
    }
  });
  
  // Bind quantity input changes
  document.addEventListener('change', function(e) {
    if (e.target.matches('.js-cart-drawer-qty')) {
      var input = e.target;
      var line = input.dataset.line;
      var newQty = Math.max(0, parseInt(input.value, 10) || 0);
      window.CartDrawer.updateQuantity(line, newQty);
    }
  });
  
  // When Ajax-cart fires after item added, open drawer
  document.body.addEventListener('afterAddItem.ajaxCart', function(e){
    console.log('[Cart drawer] - afterAddItem event received');
    window.CartDrawer.open();
  });
  
  // Manual form submission handler as backup
  document.addEventListener('submit', function(e) {
    if (e.target.matches('form[action*="/cart/add"]')) {
      console.log('[Cart drawer] - Intercepting form submission manually');
      e.preventDefault();
      
      var form = e.target;
      var formData = new FormData(form);
      
      // Simple AJAX add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(function(response) {
        if (response.ok) {
          console.log('[Cart drawer] - Item added successfully');
          window.CartDrawer.open();
        } else {
          console.error('[Cart drawer] - Error adding item');
          throw new Error('Add to cart failed');
        }
      })
      .catch(function(error) {
        console.error('[Cart drawer] - Add to cart error:', error);
        // Fall back to normal form submission
        form.submit();
      });
    }
  });
  
  // Bind additional clicks for recommendation quick adds and nav
  document.addEventListener('click', function(e){
    // Quick add
    if (e.target.closest('.js-cart-drawer-quick-add')) {
      e.preventDefault();
      var btn = e.target.closest('.js-cart-drawer-quick-add');
      var variantId = btn.dataset.variant;
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      fetch('/cart/add.js', {method:'POST', body:formData, headers:{'Accept':'application/json'}})
        .then(function(res){return res.json();})
        .then(function(){window.CartDrawer.refresh();})
        .catch(function(err){console.error('Quick add error',err);});
    }
    // Nav prev
    if (e.target.closest('.cart-drawer__upsell-prev')) {
      e.preventDefault();
      window.CartDrawer.recIndex = (window.CartDrawer.recIndex - 1 + window.CartDrawer.recs.length) % window.CartDrawer.recs.length;
      window.CartDrawer.updateRecommendationUI();
    }
    // Nav next
    if (e.target.closest('.cart-drawer__upsell-next')) {
      e.preventDefault();
      window.CartDrawer.recIndex = (window.CartDrawer.recIndex + 1) % window.CartDrawer.recs.length;
      window.CartDrawer.updateRecommendationUI();
    }
  });

  // Bind checkout button
  document.addEventListener('click', function(e) {
    if (e.target.closest('.js-cart-drawer-checkout, .ajaxcart__checkout, .onward-checkout-btn, .onward-checkout-btn__plus')) {
      console.log('[Cart drawer] - CHECKOUT CLICKED');
      window.CartDrawer.close();
      window.location.href = '/checkout';
    }
  });
  
  console.log('[Cart drawer] - Event listeners bound - MINIMAL');
});